import { render, staticRenderFns } from "./CustomerTasks.vue?vue&type=template&id=79bd8490&scoped=true&"
import script from "./CustomerTasks.vue?vue&type=script&lang=ts&"
export * from "./CustomerTasks.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerTasks.vue?vue&type=style&index=0&id=79bd8490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bd8490",
  null
  
)

export default component.exports